/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CreateBoardList } from './boardList';

export function Notice(routeProps: RouteComponentProps) {
  useEffect(() => {}, []);

  return (
    <div className="content">
      {CreateBoardList(
        routeProps,
        {
          title: '공지사항',
          subTitle: '도서출판 구민사가 전해드리는 공지사항입니다.',
          visableButton: false,
          ctgy: 'notice',
          viewUrl: '/board/boardView',
        },
        () => {},
        false
      )}
    </div>
  );
}
